var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1251 6H12.2335C13.7269 6 14.4737 6 15.0441 6.29065C15.5459 6.54631 15.9538 6.95426 16.2095 7.45603C16.5001 8.02646 16.5001 8.77319 16.5001 10.2667V12.2333C16.5001 13.7268 16.5001 14.4735 16.2095 15.044C15.9538 15.5457 15.5459 15.9537 15.0441 16.2094C14.4737 16.5 13.7269 16.5 12.2335 16.5H10.2668C8.77332 16.5 8.02658 16.5 7.45615 16.2094C6.95438 15.9537 6.54643 15.5457 6.29077 15.044C6.00012 14.4735 6.00012 13.7268 6.00012 12.2333V12.125M5.76679 12H7.73346C9.22693 12 9.97367 12 10.5441 11.7094C11.0459 11.4537 11.4538 11.0457 11.7095 10.544C12.0001 9.97354 12.0001 9.22681 12.0001 7.73333V5.76667C12.0001 4.27319 12.0001 3.52646 11.7095 2.95603C11.4538 2.45426 11.0459 2.04631 10.5441 1.79065C9.97367 1.5 9.22693 1.5 7.73346 1.5H5.76679C4.27332 1.5 3.52658 1.5 2.95615 1.79065C2.45438 2.04631 2.04643 2.45426 1.79077 2.95603C1.50012 3.52646 1.50012 4.27319 1.50012 5.76667V7.73333C1.50012 9.22681 1.50012 9.97354 1.79077 10.544C2.04643 11.0457 2.45438 11.4537 2.95615 11.7094C3.52658 12 4.27332 12 5.76679 12Z",
    stroke: "#7A7A7A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f7a35adcee273fd98e61bcdbfde69499.svg";
export { ForwardRef as ReactComponent };